import { contrastRatio } from '@yola/yola-palette-generator';
import highEmphasis from '../../rules/text/high-emphasis';
import utils from '../utils';

const { reduceColorPointByRatio, increaseColorPointByRatio } = utils;

const linkRuleDark = (params, { firstCondition, secondCondition }) => {
  const { targetColor, backgroundColor, targetColorPalette, whiteColor, blackColor } = params;
  const fallback = {
    rule: 'link.default.dark',
    params,
  };
  let calculatedColor = reduceColorPointByRatio({
    targetColor,
    backgroundColor,
    targetColorPalette,
    condition: firstCondition,
    fallback,
  });

  if (secondCondition(contrastRatio(backgroundColor, calculatedColor))) {
    return calculatedColor;
  }
  calculatedColor = increaseColorPointByRatio({
    targetColor: calculatedColor,
    backgroundColor,
    targetColorPalette,
    condition: secondCondition,
    fallback,
  });

  const ratio = contrastRatio(backgroundColor, calculatedColor);

  if (firstCondition(ratio)) {
    return calculatedColor;
  }

  return highEmphasis({ backgroundColor, whiteColor, blackColor });
};

export default linkRuleDark;
